import ResourceList from './resource-list'

export default ResourceList
